<template>
    <div class="section-container w-100 mt-4">
        <KpiOverTime :sessions="sessions" :data="data" :kpiOptions="kpiOptions" :comparisonData="comparisonKpiData">
            <template #shared-info>
                <li> Comparison data consists of all previous All Competitions matches with at least 85 minutes
                    of match time.</li>
                <li> A player requires at least 4 full matches to have comparison data.</li>
            </template>
            <template #legend>
                <LongitudinalChartLegend :includeRollingAverage="false" :includeTarget="true" />
            </template>
        </KpiOverTime>
    </div>
</template>
<script>
import KpiOption from "@/utils/KpiOption";

export default {
    props: {
        sessions: Array,
        data: Object,
        comparisonKpiData: Object
    },
    computed: {
        kpiOptions() {
            return KpiOption.options;
        },
    },
};
</script>